import BaseModule from '@/store/modules/base.module'
var baseModule = new BaseModule('product')

const state = {
  ...baseModule.state
}
const mutations = {
  ...baseModule.mutations
}
const actions = {
  ...baseModule.actions,
  images ({ commit, dispatch, getters }, {id}) {
    return dispatch('request', {
      settings: {
        url: getters.endpoint + '/' + id + '/images',
        method: 'GET'
      },
      save: false,
      refresh: false
    })
  }
}
const getters = {
  ...baseModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/product.module.js